import {
  DOC_PATH,
  DOC_CONFIG_FOLDER,
  DOC_FETCH_MODE,
  GET_TECH_DOC_BEGIN,
  GET_TECH_DOC_SUCCESS,
  GET_TECH_DOC_FAILURE,
  PRODUCT_ID_CLOUD,
  PRIMERA_CLOUD_PAGENEME,
  NIMBLE_CLOUD_PAGENEME,
  CLOUD_DOC_FOLDER_NAME,
  CLOUD_MODEL_CONFIG,
  PRODUCT_ID_PRIMERA,
  PRODUCT_ID_NIMBLE,
  PRODUCT_ID_DHCI,
  BAAS_CLOUD_PAGENEME,
  PRODUCT_ID_BAAS_5K_G,
  PRODUCT_ID_BAAS_6K_B,
  PRODUCT_ID_BAAS_9K_M,
  PRODUCT_ID_FILE,
  FILE_CLOUD_PAGENEME,
  dHCI5k6k_CLOUD_PAGENEME,
  dHCI_CLOUD_PAGENEME,
  PRODUCT_ID_DHCI_ALLETRA6K,
  PRODUCT_ID_PCBE,
  HPE_ALLETRA_DHCI,
  SIMPLIVITY_CLOUD_PAGENEME,
  PAGENAME_CABLE_SIMPLIVITY325,
  PAGENAME_CABLE_SIMPLIVITY380,
  PAGENAME_CABLE_SIMPLIVITY380PLUS,
  SIMPLIVITY_OPT_380GEN,
  SIMPLIVITY_OPT_380GEN_PLUS,
  PRODUCT_ID_OAAS,
  OAAS_CLOUD_PAGENEME,
  PAGENAME_CABLE_SIMPLIVITY325_GEN11,
  SIMPLIVITY_OPT_325GEN11,
  SIMPLIVITY_OPT_380GEN11,
  PAGENAME_CABLE_SIMPLIVITY380_GEN11,
  SDS_CLOUD_PAGENAME,
  PRODUCT_ID_SDS,
  PRODUCT_ID_ALLETRAB10K,
  DEDICATED_PLATFORM_CLOUD_PAGENEME,
  HPE_GREENLAKE_DEDICATED_PLATFORM,
} from '../constants';
import { getTechDocFolderName } from '../config/productsConfig';
export const getRackStepsSuccess = (
  payload,
  pageName,
  model,
  pageOpt,
  platform,
) => ({
  type: GET_TECH_DOC_SUCCESS,
  payload,
  pageName,
  model,
  pageOpt,
  platform,
});

export const getRackStepsBegin = () => ({
  type: GET_TECH_DOC_BEGIN,
});

export const getRackStepsFailure = (e) => ({
  type: GET_TECH_DOC_FAILURE,
  payload: e,
});

export const getWizardTechDocAction = async (params) => {
  const { pageName, dispatch, pageOpt, model, simplivitymodel, platform } =
    params;
  let { modelDocConfig, productName } = params;
  if (typeof modelDocConfig === 'object') {
    productName = modelDocConfig.productId;
    modelDocConfig = modelDocConfig.configFileName;
  }
  dispatch(getRackStepsBegin());
  const docFolderObj = getTechDocFolderName(productName);
  let docFolderName = docFolderObj.folderName;
  if (pageName === PRODUCT_ID_CLOUD) {
    docFolderName = CLOUD_DOC_FOLDER_NAME;
    modelDocConfig = CLOUD_MODEL_CONFIG;
  }
  try {
    const docFilePath = `${DOC_PATH}${docFolderName}/`;
    const configFilePath = `${docFilePath}${DOC_CONFIG_FOLDER}`;
    const docsConfigJson = await fetch(
      configFilePath + modelDocConfig,
      DOC_FETCH_MODE,
    );
    const docsConfig = await docsConfigJson.json();
    let newPageName = pageName;
    if (pageName === PRODUCT_ID_CLOUD) {
      switch (productName) {
        case PRODUCT_ID_PRIMERA:
          newPageName = PRIMERA_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_BAAS_5K_G:
        case PRODUCT_ID_BAAS_6K_B:
        case PRODUCT_ID_BAAS_9K_M:
        case PRODUCT_ID_ALLETRAB10K:
          newPageName = BAAS_CLOUD_PAGENEME;
          if (platform === HPE_GREENLAKE_DEDICATED_PLATFORM) {
            newPageName = DEDICATED_PLATFORM_CLOUD_PAGENEME;
          }
          break;
        case PRODUCT_ID_NIMBLE:
          newPageName = NIMBLE_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_DHCI:
          newPageName = dHCI_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_DHCI_ALLETRA6K:
          newPageName = dHCI5k6k_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_PCBE:
          newPageName =
            model === HPE_ALLETRA_DHCI
              ? dHCI5k6k_CLOUD_PAGENEME
              : SIMPLIVITY_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_FILE:
          newPageName = FILE_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_OAAS:
          newPageName = OAAS_CLOUD_PAGENEME;
          break;
        case PRODUCT_ID_SDS:
          newPageName = SDS_CLOUD_PAGENAME;
          break;
        default:
          break;
      }
    }
    if (pageName === PAGENAME_CABLE_SIMPLIVITY325) {
      if (simplivitymodel === SIMPLIVITY_OPT_380GEN) {
        newPageName = PAGENAME_CABLE_SIMPLIVITY380;
      }
      if (simplivitymodel === SIMPLIVITY_OPT_380GEN_PLUS) {
        newPageName = PAGENAME_CABLE_SIMPLIVITY380PLUS;
      }
      if (simplivitymodel === SIMPLIVITY_OPT_325GEN11) {
        newPageName = PAGENAME_CABLE_SIMPLIVITY325_GEN11;
      }
      if (simplivitymodel === SIMPLIVITY_OPT_380GEN11) {
        newPageName = PAGENAME_CABLE_SIMPLIVITY380_GEN11;
      }
    }
    const docFileKey = pageOpt ? `${newPageName}-${pageOpt}` : newPageName;
    const docFileNames = docsConfig[docFileKey]
      ? docsConfig[docFileKey]
      : docsConfig[newPageName];
    Promise.all(
      docFileNames.map(async (url) => {
        const pageDocContent = await fetch(docFilePath + url, DOC_FETCH_MODE);
        return await pageDocContent.text();
      }),
    ).then((resultArr) => {
      dispatch(
        getRackStepsSuccess(resultArr, pageName, model, pageOpt, platform),
      );
    });
  } catch (e) {
    dispatch(getRackStepsFailure(e));
  }
};
